import Common from './Common';

export default class Conversation {
    static approve(id) {
        const params = {
            url: `/v1/exchanges/${id}/approve`,
            method: 'patch'
        };
        return Common.request(params);
    }

    static finalize(id) {
        const params = {
            url: `/v1/exchanges/${id}/finalize`,
            method: 'patch'
        };
        return Common.request(params);
    }

    static finalizeBilling(id, data) {
        const params = {
            url: `/v1/exchanges/${id}/finalizeWithBilling`,
            method: 'patch',
            data
        };
        return Common.request(params);
    }

    // for 3x payment
    static finalizeBilling3x(id, data) {
        const params = {
            url: `/v1/exchanges/${id}/finalizeWithBilling3x`,
            method: 'patch',
            data
        };
        return Common.request(params);
    }

    static finalizeWithPaymentIntent3x(id, paymentIntentId, promoCode) {
        return Conversation.finalizeBilling3x(id, {
            payment_intent_id: paymentIntentId,
            coupon_name: promoCode
        });
    }

    static finalizeWithPaymentIntent(id, paymentIntentId, promoCode) {
        return Conversation.finalizeBilling(id, {
            payment_intent_id: paymentIntentId,
            psp: 'stripe',
            coupon_name: promoCode
        });
    }

    static finalizeWithExistingPaymentMethod(id, paymentMethodId, promoCode) {
        return Conversation.finalizeBilling(id, {
            pm_id: paymentMethodId,
            psp: 'stripe',
            coupon_name: promoCode
        });
    }

    static finalizeWithPaypal(id, braintreeNonce, braintreeDeviceData, promoCode) {
        return Conversation.finalizeBilling(id, {
            braintreeNonce,
            braintreeDeviceData,
            psp: 'braintree',
            coupon_name: promoCode
        });
    }

    static finalizeWithExistingPaypalAccount(id, pmId, promoCode) {
        return Conversation.finalizeBilling(id, {
            pm_id: pmId,
            psp: 'braintree',
            coupon_name: promoCode
        });
    }

    // Pay (subscription + GP) without finalizing the exchange
    static billing(id, data) {
        const params = {
            url: `/v1/exchanges/${id}/billing`,
            method: 'post',
            data
        };
        return Common.request(params);
    }

    // for 3x payment
    static billing3x(id, data) {
        const params = {
            url: `/v1/exchanges/${id}/billing3x`,
            method: 'post',
            data
        };
        return Common.request(params);
    }

    static billingWithPaymentIntent3x(id, paymentIntentId, promoCode) {
        return Conversation.billing3x(id, {
            payment_intent_id: paymentIntentId,
            coupon_name: promoCode
        });
    }

    static billingWithPaymentIntent(id, paymentIntentId, promoCode) {
        return Conversation.billing(id, {
            payment_intent_id: paymentIntentId,
            psp: 'stripe',
            coupon_name: promoCode
        });
    }

    static billingWithExistingPaymentMethod(id, paymentMethodId, promoCode) {
        return Conversation.billing(id, {
            pm_id: paymentMethodId,
            psp: 'stripe',
            coupon_name: promoCode
        });
    }

    static billingWithPaypal(id, braintreeNonce, braintreeDeviceData, promoCode) {
        return Conversation.billing(id, {
            braintreeNonce,
            braintreeDeviceData,
            psp: 'braintree',
            coupon_name: promoCode
        });
    }

    static billingWithExistingPaypalAccount(id, pmId, promoCode) {
        return Conversation.billing(id, {
            pm_id: pmId,
            psp: 'braintree',
            coupon_name: promoCode
        });
    }

    static cancel(id, reasonData) {
        const params = {
            url: `/v1/exchanges/${id}/cancel`,
            method: 'patch'
        };
        if (reasonData) {
            params.data = {
                reason: reasonData
            };
        }
        return Common.request(params);
    }

    static rateHome(conversationId, data) {
        const params = {
            url: `/v1/homes/rate/${conversationId}`,
            method: 'post',
            data
        };
        return Common.request(params);
    }

    static rateUser(conversationId, data) {
        const params = {
            url: `/v1/users/rate/${conversationId}`,
            method: 'post',
            data
        };
        return Common.request(params);
    }

    static async translateMessage(messageId, targetLanguage) {
        return Common.request({
            url: `/v1/messages/${messageId}/translate`,
            method: 'get',
            data: {
                target_language: targetLanguage
            }
        });
    }
}
